fragment Error on Error {
  ... on Error {
    message
  }
  __typename
}

fragment LangField on LangString {
  langCode
  value
}

fragment LockResourceError on LockResourceFailedError {
  message
  blockedInfo {
    blockers {
      userAlias
      lockTime
    }
  }
  __typename
}
